import './style.scss'
import { Slider } from '../../../js/components/Slider/Slider'

export default !function () {
  const block = document.querySelector('.training-features')

  if (!block) {
    return
  }

  const sliderContainer = block.querySelector('.training-features__slider')
  const slides = sliderContainer.querySelectorAll('.training-features__item')
  const controls = block.querySelector('.training-features__controls')
  const isInit = slides.length > 2

  if (slides.length > 2) {
    let wrapper = block.querySelector('.training-features__list')
    wrapper.classList.remove('training-features__list--not-slider')
  }

  const options = {
    wrapper: sliderContainer,
    settings: {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: false,

      effect: 'slide',

      slideClass: 'training-features__item',
      wrapperClass: 'training-features__list',

      pagination: {
        el: '.js-count',
        type: 'fraction',
      },

      navigation: {
        nextEl: '.button-arrow--next',
        prevEl: '.button-arrow--prev'
      },
    },
    modules: ['pagination', 'navigation'],
    initCondition: {
      sm: isInit,
      md: isInit,
      lg: isInit,
      xl: isInit
    },
    controls
  }

  new Slider(options).init()
}()
